import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { API_BASE } from "../lib/api";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    fetch(`${API_BASE}/auth/magic-link/verify`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }),
    })
      .then(async (r) => {
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "This sign-in link is invalid or has expired.");
        setUser(d);
        navigate("/admin", { replace: true });
      })
      .catch((e) => setError(e.message));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-[100dvh] gf-gradient-dark grid place-items-center px-5" data-testid="admin-verify-page">
      {error ? (
        <div className="max-w-sm text-center text-white">
          <XCircle className="mx-auto text-rose-300" size={40} />
          <p data-testid="admin-verify-error" className="mt-3 text-sm">{error}</p>
          <Link to="/admin/login" data-testid="admin-verify-retry-link" className="mt-4 inline-block underline text-emerald-200">Request a new link</Link>
        </div>
      ) : (
        <div className="text-emerald-100 flex items-center gap-2"><Loader2 className="animate-spin" size={20} /> Signing you in…</div>
      )}
    </div>
  );
}
